import { render, staticRenderFns } from "./AuthSide.vue?vue&type=template&id=40622bd4&scoped=true&"
import script from "./AuthSide.vue?vue&type=script&lang=js&"
export * from "./AuthSide.vue?vue&type=script&lang=js&"
import style0 from "./AuthSide.vue?vue&type=style&index=0&id=40622bd4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40622bd4",
  null
  
)

export default component.exports